export default __webpack_public_path__ + "static/media/BigCoinold (2).939918aa.svg";